import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@shared/lib/utils';

const headingVariants = cva('font-heading text-foreground tracking-normal', {
  variants: {
    size: {
      xs: 'text-tiny',
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
    },
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
  },
  defaultVariants: {
    size: 'xl',
    weight: 'bold',
  },
});

type HeadingElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  as?: HeadingElement;
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ as: Comp = 'h2', className, size, weight, ...props }, ref) => (
    <Comp ref={ref} className={cn(headingVariants({ size, weight }), className)} {...props} />
  )
);
Heading.displayName = 'Heading';

export { Heading };
